/* eslint-disable @nx/enforce-module-boundaries */
import {
  Button,
  Card,
  Stack,
  HStack,
  Spinner,
  Text,
  VStack,
  IconButton,
  Image,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
} from '@mybridge/ui';
import { forwardRef, useContext, useEffect, useRef, useState } from 'react';
import { useMyNetworkContext } from 'v4/components/network/context';
import { MyNetworkUserCard } from 'v4/components/network/network-card-full';
import { UserNetworkingActions } from 'v4/components/user-networking-actions';
import { SearchContext } from '../../context';
import { PostCardSkeleton } from 'v4/components/post/skeleton';
import { SearchCardSkeleton } from '../../search-card-skeleton';
import { ForceSignInWrapper } from 'v4/components/force-sign-in-wrapper';
import { useSelector } from 'react-redux';
import InfiniteScroll from 'react-infinite-scroll-component';
import { MyNetworkContext } from 'v4/components/network/context';
import {
  BlockIcon,
  CalendarIcon,
  CallIconNew,
  ChatIcon,
  ChatOutLined,
  DisagreeIcon,
  Message,
  ReportIcon,
  ScheduleIcon,
  SharedConnectionIcon,
  ThreeDot,
  VerticalThreeDot,
} from '@mybridge/icons';
import { MatrixContext } from 'packages/mybridgev4/context/chat-context';
import { MeetingDefaultIcon } from '@mybridge/icons/NotificationIcons';
import { Box, useDisclosure } from '@chakra-ui/react';
import { isMobile } from 'react-device-detect';
import { useRouter } from 'next/router';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { GlobalMatrixPopup } from 'v4/snippets/globalMatrixPopup';
import { getMatrixUserId, getRoomIdFromLS } from 'v4/utils/utils';
// import { MyNetworkCircleCardMenu } from 'v4/snippets/profile/network/circle-menu';
export const SearchPeopleListing = forwardRef(
  ({ count = 0, listing, isMainList, ...props }, ref) => {
    const {
      peopleSearchListing,
      refetchPeopleSearch,
      peopleSearchIsFetching,
      peopleSearchIsLoading,
      search,
      activeTab,
      peopleTotalCount,
      peopleFetchNextPage,
      peopleHasNextPage,
    } = useContext(SearchContext);
    const router = useRouter();
    const networkCtx = useContext(MyNetworkContext);
    const {
      isFriend,
      blocked,
      handshakeUser,
      handleHandshakeSendRevoke,
      revokeHandhsakeRequest,
      blockUserDisc,
      setSelectedUser,
      unfriendUser,
    } = networkCtx ?? {};
    const {
      startChatSingle,
      startChatwithUserIDifExisted,
      startMeetingSingle,
      initiateCall,
    } = useContext(MatrixContext);
    //for matrix id generation
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [nullMatrixUser, setNullMatrixUser] = useState(null);
    const [confirmAction, setConfirmAction] = useState(() => () => {});

    const { userProfileInfo } = useSelector((state) => state.userProfile);
    const { t } = useTranslator();
    useEffect(() => {
      if (!listing && activeTab === 'people') {
        refetchPeopleSearch?.();
      }
    }, [search, activeTab, listing]);

    const list = listing ?? peopleSearchListing;
console.log(blocked, 'blocked')
    return (
      <Stack w={['', '100%']} m={2} spacing={4} id="peopleSearch">
        <>
          {isMainList && list?.length > 0 ? (
            <>
              {list?.map?.((li, liIndex) => (
                <Card
                  Card
                  w={isMobile ? '96%' : '380px'}
                  minH={'177px'}
                  border="1px solid #E7E7E7"
                  borderRadius={'20px'}
                  flex={1}
                  p={4}
                  key={liIndex}
                  mx={isMobile ? 'auto' : ''}
                >
                  <MyNetworkUserCard
                    user={li}
                    isSearchCard
                    actions={
                      <VStack justifyContent="center">
                        <>
                          {isFriend?.(li) ? (
                            <HStack>
                              <HStack>
                                <Box
                                  w={'41px'}
                                  height={'41px'}
                                  border={'1px solid #00000033'}
                                  cursor="pointer"
                                  display="flex"
                                  alignItems="center"
                                  justifyContent="center"
                                  borderRadius={'50%'}
                                  _hover={{ opacity: 0.8 }}
                                  onClick={() => {
                                    const roomId = getRoomIdFromLS(li?.id);
                                    router.push(
                                      `/profile/message?user=${roomId}`
                                    );
                                  }}
                                >
                                  <ChatOutLined />
                                </Box>

                                <Box
                                  w={'41px'}
                                  height={'41px'}
                                  border={'1px solid #00000033'}
                                  cursor="pointer"
                                  display="flex"
                                  alignItems="center"
                                  justifyContent="center"
                                  borderRadius={'50%'}
                                  _hover={{ opacity: 0.8 }}
                                  onClick={() => {
                                    startMeetingSingle(li);
                                  }}
                                >
                                  <MeetingDefaultIcon
                                    height={'18px'}
                                    width={'18px'}
                                  />
                                </Box>

                                <Box
                                  w={'41px'}
                                  height={'41px'}
                                  border={'1px solid #00000033'}
                                  _hover={{ opacity: 0.8 }}
                                  cursor="pointer"
                                  display="flex"
                                  alignItems="center"
                                  justifyContent="center"
                                  borderRadius={'50%'}
                                >
                                  <ScheduleIcon
                                    color="#868585"
                                    height={'21px'}
                                    width={'21px'}
                                    onClick={(e) =>
                                      router.push(
                                        `/profile/calendar/schedule?id=${li?.id}`
                                      )
                                    }
                                  />
                                </Box>

                                <Box
                                  w={'41px'}
                                  height={'41px'}
                                  border={'1px solid #00000033'}
                                  cursor="pointer"
                                  display="flex"
                                  alignItems="center"
                                  justifyContent="center"
                                  _hover={{ opacity: 0.8 }}
                                  borderRadius={'50%'}
                                  onClick={() => {
                                    initiateCall(li);
                                  }}
                                >
                                  <CallIconNew
                                    height={'18px'}
                                    width={'18px'}
                                  />
                                </Box>
                                <Menu>
                                  <MenuButton
                                    w={'41px'}
                                    height={'41px'}
                                    border={'1px solid #00000033'}
                                    cursor="pointer"
                                    display="flex"
                                    alignItems="center"
                                    justifyContent="center"
                                    borderRadius={'50%'}
                                    variant="none"
                                    as={IconButton}
                                  >
                                    <HStack justifyContent="center">
                                      <ThreeDot width="20" height="20" />
                                    </HStack>
                                  </MenuButton>
                                  <MenuList>
                                    <MenuItem
                                      icon={
                                        <DisagreeIcon
                                          color="#E8BAB9"
                                          width="15"
                                          height="15"
                                        />
                                      }
                                      color="#868585"
                                      onClick={() => {
                                        unfriendUser?.(li);
                                      }}
                                    >
                                      {'Unfriend'}
                                    </MenuItem>
                                    <MenuItem
                                      onClick={(e) => {
                                        setSelectedUser?.(li);
                                        blockUserDisc?.onOpen?.();
                                      }}
                                      icon={
                                        <BlockIcon width="20" height="20" />
                                      }
                                      color="#868585"
                                    >
                                      {t('reportBlock.blockUser') ||
                                        'Block User'}
                                    </MenuItem>
                                  </MenuList>
                                </Menu>
                              </HStack>
                            </HStack>
                          ) : (
                            <>
                              {userProfileInfo?.id !== li?.id && (
                                <ForceSignInWrapper>
                                  <UserNetworkingActions user={li} />
                                </ForceSignInWrapper>
                              )}
                            </>
                          )}
                        </>
                      </VStack>
                    }
                  />
                </Card>
              ))}
            </>
          ) : (
            <>
              {peopleSearchIsLoading ? (
                <HStack p={4} justifyContent="center" w="100%">
                  <Spinner />
                </HStack>
              ) : (
                <>
                  {peopleTotalCount > 0 ? (
                    <>
                      <InfiniteScroll
                        dataLength={list?.length}
                        next={peopleFetchNextPage}
                        hasMore={peopleHasNextPage}
                        loader={
                          <HStack p={4} justifyContent="center" w="100%">
                            <Spinner />
                          </HStack>
                        }
                      >
                        {list?.map?.((li, liIndex) => (
                          <Card
                            maxW={['400px', '380px']}
                            minH={'177px'}
                            border="1px solid #E7E7E7"
                            borderRadius={'20px'}
                            flex={1}
                            p={4}
                            key={liIndex}
                            mb={4}
                            mx={isMobile && 'auto'}
                          >
                            <MyNetworkUserCard
                              user={li}
                              isSearchCard
                              actions={
                                <VStack justifyContent="center">
                                  <>
                                    {isFriend?.(li) ? (
                                      <HStack>
                                        <HStack>
                                          <Box
                                            w={'41px'}
                                            height={'41px'}
                                            border={'1px solid #00000033'}
                                            cursor="pointer"
                                            display="flex"
                                            alignItems="center"
                                            justifyContent="center"
                                            borderRadius={'50%'}
                                            onClick={() => {
                                              const roomId = getRoomIdFromLS(
                                                li?.id
                                              );
                                              router.push(
                                                `/profile/message?user=${roomId}`
                                              );
                                            }}
                                          >
                                            <ChatOutLined />
                                          </Box>

                                          <Box
                                            w={'41px'}
                                            height={'41px'}
                                            border={'1px solid #00000033'}
                                            cursor="pointer"
                                            display="flex"
                                            alignItems="center"
                                            justifyContent="center"
                                            borderRadius={'50%'}
                                            onClick={() => {
                                              startMeetingSingle(li);
                                            }}
                                          >
                                            <MeetingDefaultIcon
                                              height={'18px'}
                                              width={'18px'}
                                            />
                                          </Box>

                                          <Box
                                            w={'41px'}
                                            height={'41px'}
                                            border={'1px solid #00000033'}
                                            cursor="pointer"
                                            display="flex"
                                            alignItems="center"
                                            justifyContent="center"
                                            borderRadius={'50%'}
                                          >
                                            <ScheduleIcon
                                              color="#868585"
                                              height={'21px'}
                                              width={'21px'}
                                            />
                                          </Box>

                                          <Box
                                            w={'41px'}
                                            height={'41px'}
                                            border={'1px solid #00000033'}
                                            cursor="pointer"
                                            display="flex"
                                            alignItems="center"
                                            justifyContent="center"
                                            borderRadius={'50%'}
                                            onClick={() => {
                                              initiateCall(li);
                                            }}
                                          >
                                            <CallIconNew
                                              height={'18px'}
                                              width={'18px'}
                                            />
                                          </Box>
                                          <Menu>
                                            <MenuButton
                                              w={'41px'}
                                              height={'41px'}
                                              border={'1px solid #00000033'}
                                              cursor="pointer"
                                              display="flex"
                                              alignItems="center"
                                              justifyContent="center"
                                              borderRadius={'50%'}
                                              variant="none"
                                              as={IconButton}
                                            >
                                              <HStack justifyContent="center">
                                                <ThreeDot
                                                  width="20"
                                                  height="20"
                                                />
                                              </HStack>
                                            </MenuButton>
                                            <MenuList>
                                              <MenuItem
                                                icon={
                                                  <DisagreeIcon
                                                    color="#E8BAB9"
                                                    width="15"
                                                    height="15"
                                                  />
                                                }
                                                color="#868585"
                                                onClick={() => {
                                                  revokeHandhsakeRequest(li);
                                                }}
                                              >
                                                {t(
                                                  'searchPage.removeHandshake'
                                                ) || 'Remove handshake'}
                                              </MenuItem>
                                              <MenuItem
                                                onClick={(e) => {
                                                  setSelectedUser?.(user);
                                                  blockUserDisc?.onOpen?.();
                                                }}
                                                icon={
                                                  <BlockIcon
                                                    width="20"
                                                    height="20"
                                                  />
                                                }
                                                color="#868585"
                                              >
                                                {t('reportBlock.blockUser') ||
                                                  'Block User'}
                                              </MenuItem>
                                            </MenuList>
                                          </Menu>
                                        </HStack>

                                      </HStack>
                                    ) : (
                                      <>
                                        {userProfileInfo?.id !== li?.id && (
                                          <ForceSignInWrapper>
                                            <UserNetworkingActions user={li} />
                                          </ForceSignInWrapper>
                                        )}
                                      </>
                                    )}
                                  </>
                                </VStack>
                              }
                            />
                          </Card>
                        ))}
                      </InfiniteScroll>
                    </>
                  ) : (
                    <VStack
                      justifyContent="center"
                      alignItems="center"
                      h="calc(80vh - 64px)"
                    >
                      <Image
                        src="/images/defaultSearchImage.svg"
                        alt="default Image"
                        width={['80%', '400px']}
                      />
                      <Text fontSize="18px" color="#AFAFAF" fontWeight="500">
                        {t('searchPage.noResultsFound') || 'No results found'}
                      </Text>
                      <Text fontSize="14px" color="#AFAFAF" fontWeight="500">
                        {t('searchPage.tryRephrasing') ||
                          'Try shortening or rephrasing your search.'}
                      </Text>
                    </VStack>
                  )}
                </>
              )}
            </>
          )}
        </>
        <GlobalMatrixPopup
          isOpen={isOpen}
          onClose={onClose}
          onConfirm={confirmAction}
          selectedUserId={nullMatrixUser?.id}
        />
      </Stack>
    );
  }
);
